import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  DialogContentText,
  TextField,
  Box,
  Typography,
} from "@mui/material";
import CustomToggleSwitch from "../switch/Switch";

interface ConfirmationPopupProps {
  id: number;
  open: boolean;
  title: string;
  content: string;
  type?: "standard" | "form";
  inputRequired?: boolean;
  inputLabel?: string;
  inputType?: string;
  onConfirm: (id: number, input?: string, taskAssigned?: boolean) => void;
  onCancel: () => void;
  taskAssigned?: boolean;
  slotProps?: Record<string, unknown>;
}

const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({
  id,
  open,
  title,
  content,
  type,
  inputRequired,
  inputLabel,
  inputType,
  onConfirm,
  onCancel,
  taskAssigned,
  slotProps: slotPropsProp,
}) => {
  const [inputValue, setInputValue] = useState<string>("");
  const [isTaskAssigned, setIsTaskAssigned] = useState<boolean>(true);

  useEffect(() => {
    setInputValue("");
    setIsTaskAssigned(true);
  }, [open]);

  return (
    <Dialog open={open} onClose={onCancel} slotProps={slotPropsProp}>
      <DialogTitle sx={{ fontSize: 18, fontWeight: 500 }}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <span style={{ fontSize: 14 }}>{content}</span>
        </DialogContentText>
        {type === "form" ? (
          <TextField
            autoFocus
            required={inputRequired || false}
            margin="dense"
            id="dialog-content"
            name="content"
            label={inputLabel}
            type={inputType}
            fullWidth
            variant="standard"
            value={inputValue}
            slotProps={{
              inputLabel: { style: { fontSize: 12 } },
              htmlInput: { style: { fontSize: 12 } },
            }}
            onChange={(event) => setInputValue(event.target.value)}
          />
        ) : undefined}
        {taskAssigned && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1.5,
              mt: 2,
            }}
          >
            <Typography sx={{ fontSize: 14 }}>
              {" "}
              Do you want to create a task ?
            </Typography>
            <CustomToggleSwitch
              checked={isTaskAssigned}
              onChange={(e) => setIsTaskAssigned(e.target.checked)}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button sx={{ fontSize: 12 }} onClick={onCancel} color="primary">
          NO
        </Button>
        <Button
          sx={{ fontSize: 12 }}
          onClick={() => onConfirm(id, inputValue, isTaskAssigned)}
          color="secondary"
          disabled={inputRequired === true && inputValue === ""}
        >
          YES
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationPopup;
